import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (axios.isAxiosError(error)) {
          const status = error.response?.status;
          // 4xx não se resolve com nova tentativa.
          if (status && status >= 400 && status < 500) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

/** Chaves de cache centralizadas — evita invalidação por string solta. */
export const qk = {
  me: ['auth', 'me'] as const,
  organization: ['organization'] as const,
  users: (params?: unknown) => ['users', params ?? {}] as const,
  userRoles: ['users', 'roles'] as const,
  clients: (params?: unknown) => ['clients', params ?? {}] as const,
  client: (id: string) => ['clients', id] as const,
  knowledgeBase: (id: string) => ['clients', id, 'knowledge-base'] as const,
  plans: (id: string) => ['clients', id, 'plans'] as const,
  serviceAreas: (id: string) => ['clients', id, 'service-areas'] as const,
  features: (id: string) => ['clients', id, 'features'] as const,
  brandIdentity: (id: string) => ['clients', id, 'brand', 'identity'] as const,
  brandAssets: (id: string) => ['clients', id, 'brand', 'assets'] as const,
  integrations: ['integrations'] as const,
  integrationsHealth: ['integrations', 'health'] as const,
  socialAccounts: (clientId: string) => ['integrations', 'social', clientId] as const,
  campaignProjects: (params?: unknown) => ['campaign-projects', params ?? {}] as const,
  campaignProject: (id: string) => ['campaign-projects', id] as const,
  campaigns: (params?: unknown) => ['campaigns', params ?? {}] as const,
  campaign: (id: string) => ['campaigns', id] as const,
  creatives: (params?: unknown) => ['creatives', params ?? {}] as const,
  creative: (id: string) => ['creatives', id] as const,
  creativeTemplates: ['creative-templates'] as const,
  approvals: (params?: unknown) => ['approvals', params ?? {}] as const,
  approval: (id: string) => ['approvals', id] as const,
  approvalsPending: ['approvals', 'pending-count'] as const,
  metrics: (params?: unknown) => ['metrics', params ?? {}] as const,
  agencyDashboard: (params?: unknown) => ['metrics', 'agency', params ?? {}] as const,
  clientDashboard: (id: string, params?: unknown) => ['metrics', 'client', id, params ?? {}] as const,
  socialPosts: (params?: unknown) => ['social', 'posts', params ?? {}] as const,
  socialCalendar: (params?: unknown) => ['social', 'calendar', params ?? {}] as const,
  contentTopics: (params?: unknown) => ['content', 'topics', params ?? {}] as const,
  contentPosts: (params?: unknown) => ['content', 'posts', params ?? {}] as const,
  contentCalendar: (params?: unknown) => ['content', 'calendar', params ?? {}] as const,
  connectors: ['content', 'connectors'] as const,
  leads: (params?: unknown) => ['leads', params ?? {}] as const,
  funnel: (params?: unknown) => ['conversions', 'funnel', params ?? {}] as const,
  recommendations: (params?: unknown) => ['recommendations', params ?? {}] as const,
  optimizationSettings: (clientId: string) => ['optimization', 'settings', clientId] as const,
  reports: (params?: unknown) => ['reports', params ?? {}] as const,
  report: (id: string) => ['reports', id] as const,
  notifications: (params?: unknown) => ['notifications', params ?? {}] as const,
  notificationsUnread: ['notifications', 'unread-count'] as const,
  auditLogs: (params?: unknown) => ['audit-logs', params ?? {}] as const,
  aiCosts: (params?: unknown) => ['ai', 'costs', params ?? {}] as const,
  aiGenerations: (params?: unknown) => ['ai', 'generations', params ?? {}] as const,
  aiPrompts: ['ai', 'prompts'] as const,
};
